module.exports = __webpack_public_path__ + "static/media/loop.02407579.ogg";